import { FileUploadEnergyType, FileUploadFileType } from "./file-upload-interfaces";

export interface FolderInfo {
    name: string;
    numberOfFiles: string | null;
    folderColor?: string;
    folderBackgroundColor?: string;
    energyType?: FileUploadEnergyType;
    fileType?: FileUploadFileType;
}

export enum FolderType {
    INVOICE = 'INVOICE',
    CONTRACT = 'CONTRACT',
    UNCATEGORIZED = 'UNCATEGORIZED'
}